import * as React from 'react';
import { ReactNode } from 'react';

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
}

export function Tooltip({ content, children }: TooltipProps) {
  return (
    <div className="relative group">
      {children}
      <div className="absolute z-10 invisible group-hover:visible bg-slate-800 text-white text-xs rounded py-1 px-2 bottom-full left-1/2 transform -translate-x-1/2 mb-1">
        {content}
      </div>
    </div>
  );
}

// Add compatibility components for the new API
export const TooltipProvider = ({ children }: { children: ReactNode }) => (
  <>{children}</>
);
export const TooltipTrigger = ({
  asChild,
  children,
}: {
  asChild?: boolean;
  children: ReactNode;
}) => <>{children}</>;
export const TooltipContent = ({ children }: { children: ReactNode }) => (
  <>{children}</>
);
